const OfferTypeEnum = {
    internship: "internship",
    caj: "caj",
    apprenticeship: "apprenticeship",
    junior_internship: "junior_internship"
};

export default OfferTypeEnum;
